import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { backgroundColor, secondaryText } from 'styles/theme';

export const ErrorContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
    height: 100%;
    padding: 2rem;
    color: ${secondaryText};
`;

export const ErrorIcon = styled(FontAwesomeIcon)`
    font-size: 4.8rem;
    color: ${secondaryText};
`;

export const ErrorTitle = styled.h2`
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.2;
    margin: 0;
    color: ${secondaryText};
`;

export const ErrorDetails = styled.details`
    margin-top: 1rem;
    max-width: 60ch;
    width: 100%;

    summary {
        cursor: pointer;
        color: ${secondaryText};
        font-size: 1.4rem;
    }

    pre {
        background-color: ${backgroundColor};
        padding: 1rem;
        border-radius: 0.4rem;
        overflow-x: auto;
        white-space: pre-wrap;
        margin-top: 1rem;
        font-size: 1.2rem;
    }
`;
